import React, { useEffect, useState } from "react";
import HeaderDashboard from "../../components/layout/header/HeaderDashboard";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import AccountingSoftwareTitle from "./AccountingSoftwareTitle";
import DisconnectedSoftware from "./DisconnectedSoftware";
import AccountingSoftwareContact from "./AccountingSoftwareContact";
import NetworkStatus from "../../utils/networkStatus";
import { useDispatch } from "react-redux";
import InvoicePageSkeleton from "../../components/skeletons/InvoicePageSkeleton";
import { singleConnectedSoftware } from "../../redux/loginSlice";
import { useNavigate } from "react-router-dom";
import { CONNECTED, showToastType } from "../../utils/constants/appConstants";
import { INVOICE } from "../../route/paths";
import { showToast } from "../../utils/utils";
import useProfile from "../../hooks/useProfile";
import useLoginSuccessToast from "../../hooks/login/useLoginSuccessToast";

const SingleAccountingSoftware = () => {
  useLoginSuccessToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lastConnectedLoading, setLastConnectedLoading] = useState(true);

  useEffect(() => {
    const handleGetLastConnectedData = async () => {
      try {
        const response = await dispatch(singleConnectedSoftware()).unwrap();
        if (response?.data?.data?.connectionStatus === CONNECTED) {
          navigate(INVOICE);
        }
      } catch (error) {
        showToast(error.response?.data?.message, showToastType.error);
      } finally {
        setLastConnectedLoading(false);
      }
    };
    handleGetLastConnectedData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useProfile();

  return (
    <>
      <HeaderDashboard />
      <LoginAsUser />
      {lastConnectedLoading ? (
        <InvoicePageSkeleton />
      ) : (
        <div className="home-main-section">
          <div className="container">
            <AccountingSoftwareTitle />
            <DisconnectedSoftware />
            <AccountingSoftwareContact />
          </div>
        </div>
      )}
      <NetworkStatus />
    </>
  );
};

export default SingleAccountingSoftware;
